import { getLocaleStore } from '@/i18n';
import type { ProductType } from '../product-retouching-panel';

export const PRODUCT_RETOUCHING_SUB_FUNC = 'ai_goods_fix';

export const PRODUCT_TYPES = (): ProductType[] => {
    const { $t } = getLocaleStore();
    return [
        {
            label: $t((v) => v.productRetouching.common),
            value: 'general',
            icon: 'Handbag',
            showVipIcon: false,
        },
        {
            label: $t((v) => v.productRetouching.hardware),
            value: 'hardware',
            icon: 'HardwareProducts',
            showVipIcon: false,
        },
        {
            label: $t((v) => v.productRetouching.cosmetic),
            value: 'cosmetics',
            icon: 'Cosmetic',
            showVipIcon: false,
        },
        {
            label: $t((v) => v.productRetouching.leatherProducts),
            value: 'leather',
            icon: 'LeatherProducts',
            showVipIcon: false,
        },
    ];
};
